import * as o from "react";
import a from "../lib/IconBase.es.js";
import i from "../defs/ClipboardText.es.js";
const e = o.forwardRef((r, t) => /* @__PURE__ */ o.createElement(a, { ref: t, ...r, weights: i }));
e.displayName = "ClipboardTextIcon";
const c = e;
export {
  c as ClipboardText,
  e as ClipboardTextIcon
};
